export default __webpack_public_path__ + "static/sleevepe-e73a8765364cb73fda6cd831f1be38d7.jpg";